/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import { Grid } from "@material-ui/core";

//custom libraries
import {
  CustomerInformation,
  OrderDetailSection,
  OrderDetailSideBar,
  OrderComment,
} from "../containers";
import { ContentSection, SidebarSection } from "../components";
import { useOrderDetails, useSidebar } from "../hooks";
import OrganizationInformationSection from "../containers/organization-information";

export default function OrderDetail() {
  const {
    getPrevious,
    getNext,
    orderDetail,
    orderItem,
    handleLockUnLock,
    cancelOrderByID,
    checkout,
    orderComment,
    inputComment,
    saveChange,
    orderHandleChange,
    cancelChange,
    reOrderByOrderId,
    lockOrder,
    setCusinfo,
    selectedStore,
    orgInfo,
    cusinfo,
    handleChange,
    clickSubmit,
    changeCustomerStatus,
    canSave,
    editFormData,
    initializeEditForm,
    displayAlert,
  } = useOrderDetails();

  const {
    showEditForm,
    setShoweditForm,
    showCustomerControl,
    setShowCustomerControl,
  } = useSidebar();

  React.useEffect(() => {
    setShowCustomerControl(true);
  }, []);

  return (
    <Grid container className="min-content-height">
      <ContentSection>
        <OrderDetailSideBar
          {...{
            handleLockUnLock,
            orderDetail,
            cancelOrderByID,
            checkout,
            reOrderByOrderId,
            lockOrder,
            cusinfo,
          }}
        />
        <Grid container direction="column" wrap="nowrap" spacing={3}>
          <Grid item>
            <OrderDetailSection
              {...{
                getPrevious,
                getNext,
                orderDetail,
                orderItem,
              }}
            />
          </Grid>
          <Grid item>
            <OrderComment
              {...{
                saveChange,
                orderHandleChange,
                cancelChange,
                inputComment,
                orderComment,
              }}
            />
          </Grid>
          <Grid item container direction="row" spacing={3} alignItems="stretch">
            <Grid item xs={selectedStore.type === "BMH" ? 6 : 12}>
              <CustomerInformation
                {...{
                  cusinfo,
                  setCusinfo,
                  showEditForm,
                  setShoweditForm,
                  handleChange,
                  clickSubmit,
                  changeCustomerStatus,
                  showCustomerControl,
                  canSave,
                  editFormData,
                  initializeEditForm,
                  displayAlert,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              {selectedStore.type === "BMH" && (
                <OrganizationInformationSection address={orgInfo} />
              )}
            </Grid>
          </Grid>
        </Grid>
      </ContentSection>
    </Grid>
  );
}
